module.exports = __webpack_public_path__ + "static/media/kto.f4270fd3.png";